import { useEffect, useRef } from 'react';

/**
 * Закрытие вкладки и перезагрузка спрашивают подтверждение, пока `active`.
 * Функция вызывается в момент закрытия: так счётчик в ref не требует перерисовок.
 */
export function useBeforeUnload(active: boolean | (() => boolean)): void {
  const latest = useRef(active);
  latest.current = active;

  useEffect(() => {
    const handler = (event: BeforeUnloadEvent) => {
      const current = latest.current;
      if (!(typeof current === 'function' ? current() : current)) return;
      event.preventDefault();
      // Для старых браузеров: без присвоенного returnValue диалог не покажется.
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);
}
